export const ROWS = 6;
export const WEEKDAYS_AMOUNT = 7;
export const COLUMNS = WEEKDAYS_AMOUNT;
export const CELLS_AMOUNT = ROWS * COLUMNS;
